export { VisitSnackbarNotificationService } from './visit-notifications/visit-notifications.service';
export { EmulationNotification } from './visit-notifications/emulation-notificstion';
export { VisitFacade } from './visit-facade/visit-facade';
export { UserDeviceDetailsService } from '../emulation'